import { FontSizes, FontWeights, ILabelStyles, Label, Stack } from "@fluentui/react";
import React from "react";
import { LanguageContext } from "../../../../../../utilities/LocalizationModule";

const tooltipTextStyle: Partial<ILabelStyles> = {
  root: {
    fontWeight: FontWeights.regular,
    fontSize: FontSizes.small,
  }
}

export interface IPiiTooltipProps {
  isLoading?: boolean;
  PIIDetected: boolean;
  PII: string;
  piiError?: string;
}

export const PiiTooltip = ({ isLoading, PIIDetected, PII, piiError }: IPiiTooltipProps) => {
  const languageStrings = React.useContext(LanguageContext);
  return <>
    {isLoading && <Label>{languageStrings.PrivacySensitiveChecking}</Label>}
    {!isLoading && PIIDetected === true &&
      <>
        {!piiError &&<Label>{languageStrings.PrivacySensitiveDataFound}</Label>}
        <Stack>
          {PII?.split('\n').filter(x => x.length > 0).sort().map((u, i) =>
            <Label key={i} styles={tooltipTextStyle}>
              {u}
            </Label>)}
        </Stack>
      </>
    }
    {!isLoading && PIIDetected === false && PII === '-' && !piiError && <Label styles={tooltipTextStyle}>{languageStrings.PrivacySensitiveDataNotFound}</Label>}
    {!isLoading && PIIDetected === false && !PII && !piiError && <Label styles={tooltipTextStyle}>{languageStrings.PrivacySensitiveDataNotChecked}</Label>}
    {!isLoading && piiError && <Label styles={tooltipTextStyle}>{languageStrings.PrivacySensitiveCheckError}</Label>}
  </>
};
